import { Component, inject } from '@angular/core';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { SubscribeBlockComponent } from '../subscribe-block/subscribe-block.component';
import { AsyncPipe } from '@angular/common';
import { ImageModifierPipe } from '../image-modifer.pipe';

@Component({
    selector: 'tea-shop-fe-site-footer',
    templateUrl: './site-footer.component.html',
    styleUrls: ['./site-footer.component.css'],
    imports: [
        RouterLink,
        SubscribeBlockComponent,
        AsyncPipe,
        ImageModifierPipe,
    ],
})
export class SiteFooterComponent {
  private router = inject(Router);

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.smoothScrollToTop();
      }
    });
  }

  private smoothScrollToTop(): void {
    const duration = 600; // Duration in milliseconds
    const start = window.scrollY;
    const startTime = performance.now();

    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Easing function for smoother animation
      const easeInOutCubic = progress < 0.5
        ? 4 * progress * progress * progress
        : 1 - Math.pow(-2 * progress + 2, 3) / 2;

      window.scrollTo(0, start * (1 - easeInOutCubic));

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }
}
